import React, { useState } from "react";
import { UserItem, UserSettings } from "../models/user";
import {
  getAuthCookie,
  setAuthCookie,
  removeAuthCookie,
} from "../middleware/cookie-manager";
import { getAuth, signOut } from "firebase/auth";

import axios from "../middleware/axios_gql";
import { Popup } from "../models/popups";
import { ReaderItem } from "../models/reader";

type NewType = ReaderItem;

type firstLoadData = {
  popups: Popup[];
  continueReading: ReaderItem[];
  recentReading: NewType[];
};

type DataProps = {
  loaded: boolean;
  first_load: boolean;
  first_data: firstLoadData | null;
  lang_id: string;
  setLoaded: any;
  setLang: any;
  user: UserItem | false;
  setUser: any;
  setSettings: any;
  removeData: any;
  notifications?: string | null;
  setNotifications?: any;
  setfirstLoad?: any;
  setfirstDataLoad?: any;
};

type LogoutType = false | "kickout" | "inactive_teacher";

export const DataContext = React.createContext<Partial<DataProps>>({
  loaded: false,
  first_load: true,
  first_data: null,
  lang_id: "1",
  user: false,
  notifications: null,
  setUser: (user: UserItem) => {},
  setSettings: (settings: UserSettings) => {},
  setLoaded: (loaded: boolean) => {},
  setLang: (lang: string) => {},
  setNotifications: (notifications: string) => {},
  setfirstDataLoad: (data: firstLoadData) => {},
  removeData: (type: LogoutType = false) => {},
});

const DataContextProvider: React.FC = ({ children }) => {
  const local_user = getAuthCookie();
  const [is_loaded, setLoaded] = useState(false);
  const [first_load, setfirstLoad] = useState(true);
  const [notifications, setNotifications] = useState<string | null>();
  const [firstLoadData, setfirstLoadData] = useState<firstLoadData | null>();
  const [user, setUser] = useState<UserItem | false>(
    local_user && local_user.token ? local_user : false,
  );
  const [lang_id, setLang_id] = useState(local_user?.lang_id || "1");
  const setLoadedHandler = (set_loaded = "email") => {
    setLoaded(Boolean(set_loaded));
  };

  const setfirstLoadHandler = (set: boolean) => {
    setfirstLoad(set);
  };

  const setNotificationsHandler = (set_notifications = null) => {
    setNotifications(set_notifications);
  };

  const setUserHandler = (set_user: UserItem) => {
    setUser(set_user);
    setAuthCookie(set_user);
  };
  const setSettingsHandler = (
    settings: UserSettings,
    local_user?: UserItem,
  ) => {
    if (!local_user && !user) {
      return;
    } else if (!local_user) {
      local_user = user as UserItem;
    }
    const set_user = { ...local_user };
    set_user.settings = settings;
    setUser(set_user);
    setAuthCookie(set_user);
  };

  const setfirstLoadDataHandler = (data: firstLoadData) => {
    setfirstLoadData(data);
  };

  const setLangHandler = (get_lang_id: string = "1", refresh = false) => {
    const currentUser = getAuthCookie();
    if (currentUser) {
      currentUser.lang_id = get_lang_id;
      setAuthCookie(currentUser);
      setTimeout(() => {
        setLang_id(get_lang_id);
        if (refresh) {
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      }, 500);
    }
  };

  const removeData = async (type: LogoutType = false) => {
    removeAuthCookie();
    const firebaseToken = localStorage.getItem("ntt");
    if (firebaseToken) {
      await removeUserFcmToken(firebaseToken);
    }
    try {
      const auth = getAuth();
      signOut(auth);
    } catch (error) {
      console.log("data-context.tsx:64 | error", error);
    }
    if (type) {
      switch (type) {
        case "kickout":
          localStorage.setItem(
            "logoutType",
            "Your session has expired or you logged into your account on another device. Please sign in again",
          );
          break;
        case "inactive_teacher":
          localStorage.setItem(
            "logoutType",
            "Your Teacher's Membership to Flangoo is Inactive",
          );
          break;
        default:
          localStorage.setItem("logoutType", type);
      }
    }
  };
  const removeUserFcmToken = async (token: string) => {
    const data = {
      query: "mutation removeFcm($token: String!){\nlogout(token:$token)\n}",
      variables: { token: token },
      operationName: "removeFcm",
    };
    try {
      await axios.post("", data);
      return true;
    } catch (error) {
      console.log("firebase.ts:72 | error ", error);
      return false;
    }
  };
  return (
    <DataContext.Provider
      value={{
        loaded: is_loaded,
        lang_id,
        notifications,
        first_load: first_load,
        first_data: firstLoadData,
        setLoaded: setLoadedHandler,
        setNotifications: setNotificationsHandler,
        setLang: setLangHandler,
        user: user,
        removeData: removeData,
        setUser: setUserHandler,
        setSettings: setSettingsHandler,
        setfirstLoad: setfirstLoadHandler,
        setfirstDataLoad: setfirstLoadDataHandler,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export default DataContextProvider;
